import { combineEpics } from 'redux-observable';

import { checkBasketValuesEpic }   from './CheckBasketValues/CheckBasketValuesEpic';

export default combineEpics(
    checkBasketValuesEpic,
);
